"use client";
import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import Link from "next/link";
import { X } from "lucide-react";
import CTA from "./CTA";

export default function HeaderClient({ industries, services }) {
  // State for mobile menu open or closed
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // State for individual nav dropdowns (for mobile)
  const [isIndustriesDropdownOpen, setIndustriesDropdownOpen] = useState(false);
  const [isServicesDropdownOpen, setServicesDropdownOpen] = useState(false);

  const resetMenus = () => {
    setIndustriesDropdownOpen(false);
    setServicesDropdownOpen(false);
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="top-0 w-full z-50 py-7 justify-evenly bg-white fixed shadow-2xl text-neutral-900">
      <nav className="max-w-[1200px] mx-auto flex justify-between items-center px-5 lg:px-7">
        <Link
          href="/"
          onClick={() => {
            resetMenus();
          }}
        >
          <img
            src="/peak-values-brand/peak-values-consulting.svg"
            alt="Logo"
            width={150}
          />
        </Link>

        <div className="lg:hidden" onClick={toggleMenu}>
          {isMenuOpen ?
            <X className="w-6 h-6 text-neutral-900 cursor-pointer" />
          : <button className="text-white cursor-pointer">
              <span className="block w-6 h-0.5 bg-neutral-900 mb-1"></span>
              <span className="block w-6 h-0.5 bg-neutral-900 mb-1"></span>
              <span className="block w-6 h-0.5 bg-neutral-900"></span>
            </button>
          }
        </div>

        {/* DESKTOP MENU */}
        <div className="hidden lg:flex items-center gap-4 xl:gap-5 ">
          <div className="relative group">
            <Link href="/industries">Industries</Link>

            <div
              className={`absolute top-4 bg-white shadow-lg w-55 rounded-md mt-2 p-2  opacity-0 invisible group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 translate-y-2 transition-all duration-300 ease-in-out`}
            >
              {industries.map((industry) => (
                <Link
                  key={industry._id}
                  href={`/industries/${industry.slug.current}`}
                  className="block px-4 py-2 roboto-mono hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
                  onClick={() => {
                    resetMenus();
                  }}
                >
                  {industry.title}
                </Link>
              ))}
            </div>
          </div>

          <div className="relative group">
            <Link href="/services">Services</Link>

            <div
              className={`absolute top-4 bg-white shadow-lg rounded-md mt-2 p-2 w-55 opacity-0 invisible group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 translate-y-2 transition-all duration-300 ease-in-out`}
            >
              {services.map((service) => (
                <Link
                  key={service._id}
                  href={`/services/${service.slug.current}`}
                  className="block px-4 py-2 hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
                  onClick={() => {
                    resetMenus();
                  }}
                >
                  {service.title}
                </Link>
              ))}
            </div>
          </div>

          <Link
            href="/blog"
            className=" hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
            onClick={() => {
              resetMenus();
            }}
          >
            Blog
          </Link>
          <Link
            href="/case-studies"
            className=" hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
            onClick={() => {
              resetMenus();
            }}
          >
            Case Studies
          </Link>
          <Link
            href="/about"
            className=" hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
            onClick={() => {
              resetMenus();
            }}
          >
            About
          </Link>
          <Link
            href="/careers"
            className=" hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
            onClick={() => {
              resetMenus();
            }}
          >
            Careers
          </Link>
          <Link
            href="/contact"
            className="hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
            onClick={() => {
              resetMenus();
            }}
          >
            Contact
          </Link>
          <CTA resetMenus={resetMenus} />
        </div>
      </nav>

      {/* MOBILE MENU */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          isMenuOpen ? "max-h-[500px]" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col items-center mt-10">
          <div className="w-full mb-5">
            <Link
              href="#"
              className="block px-5 text-center mb-2"
              onClick={() =>
                setIndustriesDropdownOpen(!isIndustriesDropdownOpen)
              }
            >
              Industries <ChevronDown className="inline w-4 h-4" />
            </Link>
            <div
              className={`${
                isIndustriesDropdownOpen ? "max-h-[200px]" : "max-h-0"
              } overflow-hidden transition-all duration-300 ease-in-out text-center`}
            >
              {industries.map((industry) => (
                <Link
                  key={industry._id}
                  href={`/industries/${industry.slug.current}`}
                  className="block px-4 my-2 hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
                  onClick={() => {
                    resetMenus();
                  }}
                >
                  - {industry.title}
                </Link>
              ))}
            </div>
          </div>

          <div className="w-full mb-5">
            <Link
              href="#"
              className="block px-5 text-center mb-2"
              onClick={() => setServicesDropdownOpen(!isServicesDropdownOpen)}
            >
              Services <ChevronDown className="inline w-4 h-4" />
            </Link>
            <div
              className={`${
                isServicesDropdownOpen ? "max-h-[200px]" : "max-h-0"
              } overflow-hidden transition-all duration-300 ease-in-out text-center`}
            >
              {services.map((service) => (
                <Link
                  key={service._id}
                  href={`/services/${service.slug.current}`}
                  className="block px-4 my-2 hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
                  onClick={() => {
                    resetMenus();
                  }}
                >
                  - {service.title}
                </Link>
              ))}
            </div>
          </div>

          <Link
            href="/blog"
            className="mb-5 hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
            onClick={() => {
              resetMenus();
            }}
          >
            Blog
          </Link>

          <Link
            href="/case-studies"
            className="mb-5 hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
            onClick={() => {
              resetMenus();
            }}
          >
            Case Studies
          </Link>
          <Link
            href="/about"
            className="mb-5 hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
            onClick={() => {
              resetMenus();
            }}
          >
            About
          </Link>
          <Link
            href="/careers"
            className="mb-5 hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
            onClick={() => {
              resetMenus();
            }}
          >
            Careers
          </Link>
          <Link
            href="/contact"
            className="mb-5 hover:text-[#05cc6d] transition-all duration-300 ease-in-out"
            onClick={() => {
              resetMenus();
            }}
          >
            Contact
          </Link>
          <CTA resetMenus={resetMenus} />
        </nav>
      </div>
    </header>
  );
}
